import React from 'react'

const Flexbox_Corse_Exam = () => {
  return (
    <div>
      <h1>Flexbox Course Exam</h1>
    </div>
  )
}

export default Flexbox_Corse_Exam
